<template>
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.3474 8.33625L12.1837 13.5L17.3474 18.6638L15.7499 20.25L8.99991
      13.5L15.7499 6.75L17.3474 8.33625Z"
      fill="#506784"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.19995 19.8L7.19995 7.20001H9.19995V19.8H7.19995Z"
      fill="#506784"
    />
  </svg>
</template>

<script>
export default {}
</script>
